export default __webpack_public_path__ + "static/media/Bebas Neue Pro Regular.3d7bd366.otf";